module.exports = __webpack_public_path__ + "img/finish-fail.c3c04029.svg";